module.exports = __webpack_public_path__ + "static/img/train_img.92164bea.png";